import type { FC } from 'react';
import styles from './ReferencesItem.module.scss';
import { WorkerReference } from 'redux/Api/referencesApi/type';
import { ReferenceActions } from './ReferenceActions';

interface ReferencesItemTypes {
  reference: WorkerReference;
  hidePerformer: boolean;
  workerId?: string;
}

export const ReferencesItem: FC<ReferencesItemTypes> = ({
  reference,
  hidePerformer = false,
  workerId,
}) => {
  return (
    <div className={hidePerformer ? styles.rootNoPerformer : styles.root}>
      <p>{reference.name}</p>
      <p>{reference.date}</p>
      <p>{reference.created_by}</p>
      <div className={styles.actions}>
        <ReferenceActions reference={reference} workerId={workerId} />
      </div>
    </div>
  );
};
